import { forwardRef } from 'react';
import { Input } from '@accure/ui';

import { cls } from '@/utils/cls';

export type GhostInputProps = React.ComponentProps<'input'>;

const GhostInput = forwardRef<HTMLInputElement, GhostInputProps>(function (
  { className, ...props },
  ref,
) {
  return (
    <Input
      {...props}
      ref={ref}
      className={cls(
        'border-transparent shadow-none hover:border-neutral-200',
        className,
      )}
    />
  );
});

GhostInput.displayName = 'GhostInput';
export { GhostInput };
